import Link from 'next/link';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';

import ScrollableBlogPosts from 'src/components/ScrollableBlogPosts';
import { blogCategoryUrl } from 'src/services/route-utils';

type Props = {
    category: any;
    posts: any[];
};

export default function CategoryPosts({ category, posts }: Props) {
    return (
        <ScrollableBlogPosts
            blogPosts={posts}
            moreCard={
                posts.length < 10 ? undefined : (
                    <div className="flex h-full items-center bg-white p-8">
                        <Link className="font-display text-4xl" href={blogCategoryUrl(category)}>
                            Vezi toate articolele din categorie <HiOutlineArrowNarrowRight />
                        </Link>
                    </div>
                )
            }
        />
    );
}
